/* RESPONSIBLE TEAM: team-inbox */
import Rule from 'embercom/models/inbox/conversation-rules/rule';

export default Rule.extend({
  entityString: 'sla_rule',
  subRouteString: 'slas',
  allowedRuleActions: ['apply-conversation-sla'],
});
